import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getAllCustomers: { args: ["payload"], meta: { async: true } },
    getCustomerWithId: { args: ["payload"], meta: { async: true } },
    addCustomer: { args: ["payload"], meta: { async: true } },
    editCustomer: { args: ["payload"], meta: { async: true } },
    deleteCustomer: { args: ["payload"], meta: { async: true } },

    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/customers/",
  }
);
export const ActionTypes = Types;
export default Creators;
